var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87231 30.125H23.7056C25.3706 30.125 26.9674 29.4636 28.1447 28.2863C29.322 27.109 29.9834 25.5122 29.9834 23.8472V5.01389C29.9834 4.1814 29.6527 3.38301 29.0641 2.79436C28.4754 2.2057 27.677 1.875 26.8445 1.875H11.1501C10.3176 1.875 9.51922 2.2057 8.93056 2.79436C8.34191 3.38301 8.0112 4.1814 8.0112 5.01389V25.4167C8.0112 28.0172 7.47288 30.125 4.87231 30.125Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7334 12.8611C1.7334 12.0286 2.0641 11.2302 2.65276 10.6416C3.24141 10.0529 4.0398 9.72223 4.87229 9.72223H8.01118V26.2014C8.01118 28.3672 7.03812 30.125 4.87229 30.125C2.70645 30.125 1.7334 28.3672 1.7334 26.2014V12.8611Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8585 11.2917C16.7253 11.2917 17.428 10.589 17.428 9.72222C17.428 8.85544 16.7253 8.15277 15.8585 8.15277C14.9917 8.15277 14.2891 8.85544 14.2891 9.72222C14.2891 10.589 14.9917 11.2917 15.8585 11.2917Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2891 23.8472H18.9974M14.2891 19.1389H23.7057H14.2891Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.d1d9c4579d650a6fe58b008bd5304819.svg";
export { ForwardRef as ReactComponent };